/* Marinelie — Quiz-Start auf der Startseite: Querfilm ab 990px und die
   Hoehe unter dem Kopf. Ohne dieses Skript laeuft der Hochkant-Film, der
   fest im Tag steht, und die Hoehe faellt auf 91px Kopf zurueck. */
(function () {
  'use strict';

  function init() {
    var wurzel = document.querySelector('[data-ml-qa]');
    if (!wurzel) return;

    function messen() {
      var oben = wurzel.getBoundingClientRect().top + window.scrollY;
      if (oben > 0) wurzel.style.setProperty('--ml-qa-oben', Math.round(oben) + 'px');
    }
    messen();
    window.addEventListener('resize', messen);

    var v = wurzel.querySelector('[data-ml-qa-film]');
    if (!v) return;
    var mq = window.matchMedia('(min-width: 990px)');
    function spielen() {
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function setzen() {
      var quer = mq.matches && v.getAttribute('data-quer');
      var u = quer || v.getAttribute('data-hoch');
      var bild = (quer && v.getAttribute('data-poster-quer')) || v.getAttribute('data-poster-hoch');
      if (bild) v.setAttribute('poster', bild);
      if (u && v.getAttribute('src') !== u) { v.setAttribute('src', u); v.load(); }
      spielen();
    }
    setzen();
    if (mq.addEventListener) mq.addEventListener('change', setzen);
    /* Safari bleibt am Ende teils stehen (Otton 23.10.: "video soll loopen"). */
    v.addEventListener('ended', function () { v.currentTime = 0; spielen(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
